import { render, staticRenderFns } from "./Print-Text.vue?vue&type=template&id=5b308e02&scoped=true&"
import script from "./Print-Text.vue?vue&type=script&lang=js&"
export * from "./Print-Text.vue?vue&type=script&lang=js&"
import style0 from "./Print-Text.vue?vue&type=style&index=0&id=5b308e02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b308e02",
  null
  
)

export default component.exports